document.addEventListener("DOMContentLoaded", function () {
    // Campi cliente
    const clientNameInput = document.getElementById("clientName");
    const issueDateInput = document.getElementById("issueDate");
    const cityInput = document.getElementById("city");
    const addressInput = document.getElementById("address");
    const emailInput = document.getElementById("email");
    const phoneInput = document.getElementById("phone");
    const taxCodeInput = document.getElementById("taxCode");
    const installDateInput = document.getElementById("installDate");
    const consultantSelect = document.getElementById("consultant");

    // Informazioni casa
    const houseSizeInput = document.getElementById("houseSize");
    const bathroomCountInput = document.getElementById("bathroomCount");
    const chimneyTypeSelect = document.getElementById("chimneyType");
    const thermostatCompatibleSelect = document.getElementById("thermostatCompatible");
    const caldaiaModelloSelect = document.getElementById("caldaiaModello");

    // Kit aggiuntivi
    const thermostatSelect = document.getElementById("thermostat");
    const valvesSelect = document.getElementById("valves");
    const pumpCheckbox = document.getElementById("pump");
    const acidReducerCheckbox = document.getElementById("acidReducer");
    const carterSelect = document.getElementById("carter");
    const cassoneSelect = document.getElementById("cassone");
    const cestelloCheckbox = document.getElementById("cestello");
    const tubatureExtraInput = document.getElementById("tubatureExtra");

    // Sconto
    const applyDiscountCheckbox = document.getElementById("applyDiscount");
    const discountAmountInput = document.getElementById("discountAmount");

    // Pulsante di calcolo
    const calculateButton = document.getElementById("calculateButton");
  const downloadPDFButton = document.getElementById("downloadPDF");

    // Risultati
    const clientDetailsOutput = document.getElementById("clientDetailsOutput");
    const modelOutput = document.getElementById("modelOutput");
    const kwOutput = document.getElementById("kwOutput");
    const detailsOutput = document.getElementById("detailsOutput");
    const totalPriceOutput = document.getElementById("totalPrice");
    const totalPriceIVAOutput = document.getElementById("totalPriceIVA");

    // Prezzi delle caldaie
    const caldaiaPrezzi = {
        "victrix_tera_24": { price: 2360, kw: 24 },
        "victrix_tera_28": { price: 2600, kw: 28 },
        "victrix_tera_vip": { price: 2595, kw: 0 },
        "victrix_tera_plus": { price: 2360, kw: 24 },
        "nike_eco_24": { price: 2300, kw: 24 },
        "nike_avio_24": { price: 2700, kw: 24 },
        "victrix_extra_plus": { price: 3100, kw: 0 },
        "victrix_extra_32": { price: 2900, kw: 32 },
        "victrix_zeus_25": { price: 3300, kw: 25 },
        "victrix_zeus_35": { price: 3600, kw: 35 },
        "victrix_zeus_superior_25": { price: 3540, kw: 25 },
        "victrix_zeus_superior_30": { price: 3690, kw: 30 },
        "victrix_zeus_superior_35": { price: 3955, kw: 35 },
        "ares_condensing_32": { price: 4390, kw: 32 },
        "mini_hercules_32": { price: 4190, kw: 32 },
        "hercules_26": { price: 4825, kw: 26 },
        "hercules_32": { price: 5240, kw: 32 },
        "hercules_32_abt": { price: 5750, kw: 32 }
    };

    // Prezzi dei kit aggiuntivi
    const kitPrezzi = {
        "thermostat": { "seitron": 150, "seitron_wireless": 180, "crono7": 200, "crono7_wireless": 230, "carv2": 250, "carv2_wireless": 280 },
        "valves": { "testina": 30, "valvola": 50 },
        "pump": 150,
        "acidReducer": 200,
        "carter": { "rapida": 80, "boiler": 100 },
        "cassone": { "rapida": 150, "boiler": 0 }, // Prezzo da confermare per boiler
        "cestello": 200
    };

    function calcolaPreventivo() {
        const modelloSelezionato = caldaiaModelloSelect.value;
        if (!modelloSelezionato) {
            alert("Seleziona un modello di caldaia!");
            return;
        }

        const prezzoCaldaia = caldaiaPrezzi[modelloSelezionato].price || 0;
        const kwCaldaia = caldaiaPrezzi[modelloSelezionato].kw || "-";
        let prezzoTotale = prezzoCaldaia;

        // Creazione lista kit aggiuntivi selezionati
        let kitAggiuntivi = [];
        if (thermostatSelect.value) kitAggiuntivi.push(`- ${thermostatSelect.options[thermostatSelect.selectedIndex].text}`);
        if (valvesSelect.value) kitAggiuntivi.push(`- ${valvesSelect.options[valvesSelect.selectedIndex].text}`);
        if (pumpCheckbox.checked) kitAggiuntivi.push("- Pompetta di rilancio");
        if (acidReducerCheckbox.checked) kitAggiuntivi.push("- Abbattitore acidità");
        if (carterSelect.value) kitAggiuntivi.push(`- ${carterSelect.options[carterSelect.selectedIndex].text}`);
        if (cassoneSelect.value) kitAggiuntivi.push(`- ${cassoneSelect.options[cassoneSelect.selectedIndex].text}`);
        if (cestelloCheckbox.checked) kitAggiuntivi.push("- Cestello per lavori in quota");
        if (tubatureExtraInput.value) kitAggiuntivi.push(`- Tubature extra: ${tubatureExtraInput.value}€`);

        // Calcolo costo aggiuntivi
        prezzoTotale += kitPrezzi.thermostat[thermostatSelect.value] || 0;
        prezzoTotale += kitPrezzi.valves[valvesSelect.value] || 0;
        prezzoTotale += pumpCheckbox.checked ? kitPrezzi.pump : 0;
        prezzoTotale += acidReducerCheckbox.checked ? kitPrezzi.acidReducer : 0;
        prezzoTotale += kitPrezzi.carter[carterSelect.value] || 0;
        prezzoTotale += kitPrezzi.cassone[cassoneSelect.value] || 0;
        prezzoTotale += cestelloCheckbox.checked ? kitPrezzi.cestello : 0;
        prezzoTotale += parseFloat(tubatureExtraInput.value) || 0;

        // Applicazione sconto se selezionato
        let sconto = 0;
        if (applyDiscountCheckbox.checked) {
            sconto = parseFloat(discountAmountInput.value) || 0;
            prezzoTotale -= sconto;
        }

        // Calcolo IVA (10%)
        const iva = 1.10;
        const prezzoIVA = prezzoTotale * iva;

        // Riepilogo scelte
        const dettagliCliente = `
            <strong>Committente:</strong> ${clientNameInput.value}<br>
            <strong>Data emissione preventivo:</strong> ${issueDateInput.value}<br>
            <strong>Città:</strong> ${cityInput.value}<br>
            <strong>Indirizzo:</strong> ${addressInput.value}<br>
            <strong>Telefono:</strong> ${phoneInput.value}<br>
            <strong>Email:</strong> ${emailInput.value}<br>
            <strong>Consulente:</strong> ${consultantSelect.options[consultantSelect.selectedIndex].text}
        `;

        // Output dei risultati
        clientDetailsOutput.innerHTML = dettagliCliente;
        modelOutput.innerText = caldaiaModelloSelect.options[caldaiaModelloSelect.selectedIndex].text;
        kwOutput.innerText = kwCaldaia;
        detailsOutput.innerHTML = kitAggiuntivi.length ? kitAggiuntivi.join("<br>") : "Nessun kit selezionato.";
        totalPriceOutput.innerText = prezzoTotale.toFixed(2) + " €";
        totalPriceIVAOutput.innerText = prezzoIVA.toFixed(2) + " €";
    }

    calculateButton.addEventListener("click", calcolaPreventivo);
downloadPDFButton.addEventListener("click", scaricaPDF);
function scaricaPDF() {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text("Preventivo Caldaia Immergas", 10, 10);

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    
    // Aggiungi i dettagli del cliente
    doc.text(`Committente: ${clientNameInput.value}`, 10, 30);
    doc.text(`Data preventivo: ${issueDateInput.value}`, 10, 40);
    doc.text(`Città: ${cityInput.value}`, 10, 50);
    doc.text(`Indirizzo: ${addressInput.value}`, 10, 60);
    doc.text(`Telefono: ${phoneInput.value}`, 10, 70);
    doc.text(`Email: ${emailInput.value}`, 10, 80);
    doc.text(`Consulente: ${consultantSelect.options[consultantSelect.selectedIndex].text}`, 10, 90);

    // Aggiungi i dettagli dell'impianto
    doc.text("Dettagli impianto:", 10, 110);
    doc.text(`Modello: ${modelOutput.innerText}`, 10, 120);
    doc.text(`Potenza: ${kwOutput.innerText}`, 10, 130);
    doc.text(`Metri quadri: ${houseSizeInput.value} m²`, 10, 140);
    doc.text(`Bagni: ${bathroomCountInput.value}`, 10, 150);
    doc.text(`Tipo di camino: ${chimneyTypeSelect.options[chimneyTypeSelect.selectedIndex].text}`, 10, 160);
    doc.text(`Termostato compatibile: ${thermostatCompatibleSelect.options[thermostatCompatibleSelect.selectedIndex].text}`, 10, 170);

    // Aggiungi kit aggiuntivi selezionati
    let kitY = 180;
    if (detailsOutput.innerHTML !== "Nessun kit selezionato.") {
        doc.text("Kit aggiuntivi:", 10, kitY);
        kitY += 10;
        detailsOutput.innerHTML.split("<br>").forEach((kit) => {
            doc.text(kit, 10, kitY);
            kitY += 10;
        });
    }

    // Aggiungi i prezzi
    doc.text(`Prezzo Totale (IVA esclusa): ${totalPriceOutput.innerText}`, 10, kitY + 20);
    doc.text(`Prezzo Totale (IVA inclusa, 10%): ${totalPriceIVAOutput.innerText}`, 10, kitY + 30);

    doc.save("Preventivo_Caldaia.pdf");
}
// Funzione per generare il PDF con i dati compilati
async function generaPDF() {
        // Carica il PDF originale da Shopify
        const existingPdfBytes = await fetch("https://cdn.shopify.com/s/files/1/0913/2376/0985/files/Preventivo_Caldaia.pdf?v=1741969406").then(res => res.arrayBuffer());

        // Carica PDF-Lib
        const { PDFDocument, rgb } = PDFLib;
        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const pages = pdfDoc.getPages();

        // Se il PDF ha più pagine
        const page1 = pages[0];
        const page2 = pages[1];
        const page3 = pages[2];

        // *** INSERISCI I DATI NEI CAMPI DEL PDF ***

        // Pagina 1 - Dati Committente
        page1.drawText(clientNameInput.value, { x: 150, y: 720, size: 12, color: rgb(0, 0, 0) });

        // Pagina 2 - Dettagli Preventivo
        page2.drawText(issueDateInput.value, { x: 450, y: 700, size: 12, color: rgb(0, 0, 0) });
        page2.drawText(cityInput.value, { x: 150, y: 680, size: 12, color: rgb(0, 0, 0) });
        page2.drawText(addressInput.value, { x: 150, y: 660, size: 12, color: rgb(0, 0, 0) });
        page2.drawText(taxCodeInput.value, { x: 150, y: 640, size: 12, color: rgb(0, 0, 0) });
        page2.drawText(emailInput.value, { x: 150, y: 620, size: 12, color: rgb(0, 0, 0) });
        page2.drawText(phoneInput.value, { x: 150, y: 600, size: 12, color: rgb(0, 0, 0) });
        page2.drawText(installDateInput.value, { x: 150, y: 580, size: 12, color: rgb(0, 0, 0) });
        page2.drawText(consultantSelect.value, { x: 150, y: 560, size: 12, color: rgb(0, 0, 0) });

        // Pagina 3 - Dettagli Caldaia e Prezzo
        page3.drawText(caldaiaModelloSelect.options[caldaiaModelloSelect.selectedIndex].text, { x: 200, y: 500, size: 12, color: rgb(0, 0, 0) });
        page3.drawText(document.getElementById("kwOutput").innerText, { x: 450, y: 500, size: 12, color: rgb(0, 0, 0) });
        page3.drawText(document.getElementById("totalPriceIVA").innerText, { x: 300, y: 200, size: 14, color: rgb(1, 0, 0) });

        // Salva il PDF con i dati inseriti
        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Preventivo_Caldaia_Compilato.pdf";
        link.click();
    }

    // Aggiungi l'evento al pulsante per generare il PDF
    downloadPDFButton.addEventListener("click", generaPDF);
});

